import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

export type CPSponsorSettingsLoc =
	| 'CPProfileSponsorSettingsTitle'
	| 'CPProfileSponsorSettingsDescription'
	| 'CPProfileSponsorSettingsUpdate'
	| 'CPProfileAttributesSectionTitle';

export const cpSponsorSettingsLocs: LocDefs<CPSponsorSettingsLoc> = {
	CPProfileSponsorSettingsUpdate: {
		defaultValue: 'Update',
		description: 'Update button for sponsor settings fields.',
		displayPath: `Profile|Sponsor Settings|Update`,
		displayType: 'Button',
		feature: HubFeature.CandidateProfileCustomDataSettings,
		portal: 'CP',
		legacyName: 'CandidateProfile.CustomData.Settings/Profile.Settings.Button.Update',
		shared: false,
		htmlAllowed: false,
	},
	CPProfileSponsorSettingsTitle: {
		defaultValue: 'Sponsor Settings',
		description: 'Title for sponsor settings fields.',
		displayPath: `Profile|Sponsor Settings|Title`,
		displayType: 'Title',
		legacyName: 'CandidateProfile.CustomData.Settings/Profile.Settings.Title.PageTitle',
		feature: HubFeature.CandidateProfileCustomDataSettings,
		portal: 'CP',
		shared: false,
		htmlAllowed: false,
	},
	CPProfileSponsorSettingsDescription: {
		defaultValue: '',
		description: 'Description for sponsor settings page.',
		displayPath: `Profile|Sponsor Settings|Description`,
		displayType: 'Content',
		legacyName: 'CandidateProfile.CustomData.Settings/Profile.Settings.Content.PageDescription',
		feature: HubFeature.CandidateProfileCustomDataSettings,
		portal: 'CP',
		shared: false,
		htmlAllowed: true,
	},
	CPProfileAttributesSectionTitle: {
		defaultValue: 'Attributes',
		description: 'Title for the attributes section.',
		displayPath: `Profile|Affiliation|Attributes Section`,
		displayType: 'Title',
		legacyName: 'CandidateProfile.CustomData.Attributes/Profile.Attributes.Title.Attributes',
		feature: HubFeature.CandidateProfileCustomDataAttributes,
		portal: 'CP',
		htmlAllowed: false,
		shared: false,
	},
};

export const cpSponsorSettingsLocKeys = MapLocKeys<CPSponsorSettingsLoc>(cpSponsorSettingsLocs);
export type CPSponsorSettingsLocKeys = typeof cpSponsorSettingsLocKeys;
